import request from '@core/services/request';

export const oauthAPI = {
	richtable: (req: any) => request.post(`/oauth/richtable`, req),
	getClients: (userId: any) => request.get(`/oauth/clients/${userId}`),
	getUserTokens: (userId: any) => request.get(`/oauth/tokens/${userId}`),
	createUser: (companyUser: any) => request.post(`/oauth/register-user`, companyUser),
	upsertUser: (companyUser: any) => request.post(`/oauth/user/upsert`, companyUser),
	upsertClient: (client: any) => request.post(`/oauth/client/upsert`, client),
	upsertToken: (token: any) => request.post(`/oauth/token/upsert`, token),
	createClient: (createClientRequest: any) => request.post(`/oauth/register-client`, createClientRequest),
	revokeTokenAccess: (tokenId: any) => request.get(`/oauth/revoke?tokenId=${tokenId}`),
};
